module.exports = __webpack_public_path__ + "static/logo-810fcc3145a48c199ae93d0020f982b0.png";